import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export enum FormStatus {
  DISABLED = 'disabled',
  READONLY = 'readonly',
  EDIT = 'edit',
}

@Injectable({ providedIn: 'root' })
export class FormStatusService {
  value: Observable<FormStatus> = of(FormStatus.EDIT);
}
